import { FC, PropsWithChildren } from "react";
// import { usePathname } from "next/navigation";
import Box from "@mui/material/Box";

import LayoutScripts from "../LayoutScripts";
import Alerts from "@/components/common/Alerts";
import AlertDialog from "@/components/common/AlertDialogs";
import Navbar from "@/components/layout/Navbar";
import Sidebar from "@/components/layout/Sidebar";
import Footer from "@/components/layout/Footer";
// import MonumetricAd from "@/components/adverts/MonumetricAd";

const DesktopLayout: FC<PropsWithChildren> = ({ children }) => {
  // const pathname = usePathname() as string;
  // const isThread = pathname.includes("/idea/");

  return (
    <>
      <LayoutScripts />
      <Box
        sx={{
          display: {
            xs: "none",
            sm: "none",
            md: "block",
            lg: "block",
            xl: "block",
          },
          position: "relative",
        }}
      >
        <Alerts />
        <AlertDialog />
        <Navbar />
        <Sidebar />
        <main
          style={{
            height: "100vh",
            width: "calc(100vw - 335px)",
            maxWidth: "calc(100vw - 335px)",
            overflowX: "hidden",
            overflowY: "auto",
            flex: 1,
            paddingTop: 78,
            paddingBottom: "3.5em",
            position: "fixed",
            top: 0,
            left: 335,
          }}
        >
          {children}
        </main>
        {/* {!isThread && <MonumetricAd variant="footer-in-screen" />} */}
        <Footer />
      </Box>
    </>
  );
};

export default DesktopLayout;
